export type BaseUploadOptions = {
  description: string
  password: string
  isPassword: boolean
  isPrivate: boolean
  isPrivateReport: boolean
  skipWhitelisted: boolean
  showPropagate: boolean
  propagateTags: boolean
  isTerms: boolean
  tags: string[]
}

export const baseUploadOptionsDefaults = {
  description: '',
  password: '',
  isPassword: false,
  isPrivate: false,
  isPrivateReport: false,
  skipWhitelisted: false,
  showPropagate: false,
  propagateTags: true,
  isTerms: false,
  tags: [],
}

export enum ScanEngine {
  Internal = 'internal',
  MDCloud = 'mdcloud',
}

export enum ScanEngineLabel {
  Internal = 'Internal',
  MDCloud = 'MDCloud',
}

export enum MDCloudReportType {
  Local = 'local',
  Alien = 'alien',
}
